import { Dispatch } from 'redux';

import ReservationService from '~/services/ReservationService';

export const FETCH_PROMOTIONS_REQUEST = 'FETCH_PROMOTIONS_REQUEST';
export const FETCH_PROMOTIONS_SUCCESS = 'FETCH_PROMOTIONS_SUCCESS';
export const FETCH_PROMOTIONS_FAILURE = 'FETCH_PROMOTIONS_FAILURE';

export const fetchPromotionsRequest = () => ({
  type: FETCH_PROMOTIONS_REQUEST,
});

export const fetchPromotionsSuccess = (payload: { promotions: Array<App.RatePlanPromotion>; total: number }) => ({
  type: FETCH_PROMOTIONS_SUCCESS,
  payload,
});

export const fetchPromotionsFailure = (error: string) => ({
  type: FETCH_PROMOTIONS_FAILURE,
  payload: error,
});

export const fetchPaginatedPromotions =
  (source: string, page?: number, limit?: number) => async (dispatch: Dispatch) => {
    dispatch(fetchPromotionsRequest());

    try {
      const response = await ReservationService.getPromotionsBySource(source, page, limit);

      dispatch(
        fetchPromotionsSuccess({
          promotions: response.result,
          total: response.total,
        }),
      );
    } catch (error) {
      dispatch(fetchPromotionsFailure(error));
    }
  };
